
            <div>

                <button (click)="selectedTab('ios')" [ngClass]="activeTab == 'ios' ? 'active-btn' : 'nonactive-btn-ios'"
                    class="btn" type="submit"> IOS Preview </button>
                <button (click)="selectedTab('android')"
                    [ngClass]="activeTab == 'android' ? 'active-btn' : 'nonactive-btn-android'" class="btn" type="submit">
                    Android Preview </button>
            </div>